import { NgModule } from '@angular/core';
import { CheckoutFeatureModule } from './checkout/checkout-feature.module';
import { ProductFeatureModule } from './product/product-feature.module';
import { CatalogFeatureModule } from './catalog/catalog-feature.module';
import { ParcellabFeatureModule } from './parcellab/parcellab-feature.module';
import { CartFeatureModule } from './cart/cart-feature.module';
import { HabaProductDetailsPageModule } from './product/product-details-page.module';
import { UserFeatureModule } from './user/user-feature.module';

@NgModule({
  declarations: [],
  imports: [
    HabaProductDetailsPageModule,
    ProductFeatureModule,
    CheckoutFeatureModule,
    CartFeatureModule,
    // Haba modules
    CatalogFeatureModule,
    ParcellabFeatureModule,
  ],
})
export class FeaturesModule {}
